import { isSddFinding } from './findingClassification';

function textOf(value) {
  return String(value || '').toLowerCase();
}

function fieldText(finding) {
  return [
    finding?.module,
    finding?.sourceModule,
    finding?.source,
    finding?.category,
    finding?.fingerprint,
    finding?.detail?.sourceModule,
    finding?.detail?.additionalData?.sourceModule,
    finding?.detail?.additionalData?.sourceType,
  ].map(textOf).join(' ');
}

export function routeForFinding(finding) {
  const text = fieldText(finding);

  if (isSddFinding(finding) || /\bsensitive[-_\s]?data\b/.test(text)) {
    return { path: '/client/sensitive-data', label: 'Sensitive Data' };
  }

  if (/\bad[-_\s]?(security|assessment|assessor|inventory|attack|ldap|domain)\b/.test(text)
    || text.includes('active-directory')
    || text.includes('bloodhound')
    || text.includes('kerberoast')
    || text.includes('cert-template')
    || text.includes('adcs')) {
    return { path: '/client/ad-security', label: 'AD Security' };
  }

  if (/\b(dast|zap|owasp|web[-_\s]?scan|nuclei)\b/.test(text)) {
    return { path: '/client/dast', label: 'DAST' };
  }

  if (/\b(m365|azure|aws|cspm|cloud|entra|sharepoint|teams|s3|blob)\b/.test(text)) {
    return { path: '/client/cloud-security', label: 'Cloud Security' };
  }

  if (/\b(osint|shodan|hibp|dehashed|breach|credential|domain|dns|securitytrails|certspotter|crtsh)\b/.test(text)) {
    return { path: '/client/osint', label: 'OSINT' };
  }

  return { path: '/client/findings', label: 'Findings' };
}

export function findingBackTarget(finding, state) {
  const fromPath = typeof state?.fromPath === 'string' ? state.fromPath : '';
  const fromLabel = typeof state?.fromLabel === 'string' ? state.fromLabel : '';

  if (fromPath.startsWith('/client/') && !fromPath.startsWith('/client/findings/')) {
    return { path: fromPath, label: fromLabel || routeForFinding(finding).label };
  }

  return routeForFinding(finding);
}

export function openFindingDetail(navigate, findingOrId, location, fromLabel = 'Findings') {
  const finding = typeof findingOrId === 'object' && findingOrId ? findingOrId : null;
  const id = typeof findingOrId === 'string'
    ? findingOrId
    : findingOrId?.id || findingOrId?.findingId;

  if (!id) return;

  const fromPath = `${location?.pathname || '/client/findings'}${location?.search || ''}`;
  navigate(`/client/findings/${id}`, {
    state: {
      fromPath,
      fromLabel,
      finding,
    },
  });
}
